import { render } from "./MCheckboxGroup.vue?vue&type=template&id=49e0066e&scoped=true"
import script from "./MCheckboxGroup.vue?vue&type=script&lang=js"
export * from "./MCheckboxGroup.vue?vue&type=script&lang=js"

import "./MCheckboxGroup.vue?vue&type=style&index=0&id=49e0066e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e0066e"]])

export default __exports__